export enum HubloPoolProfileStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  WAITING_REAPPROVAL = 'WAITING_REAPPROVAL',
}
